

// import React, { useState, useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// export default function Login() {
//   const history = useHistory();
//   const location = useLocation();

//   // --- Logic (Unchanged) ---
//   const queryParams = new URLSearchParams(location.search);
//   const referFromUrl = queryParams.get("refer");
//   const [referral, setReferral] = useState(
//     referFromUrl || localStorage.getItem("referral") || ""
//   );

//   useEffect(() => {
//     if (referFromUrl) {
//       localStorage.setItem("referral", referFromUrl);
//       setReferral(referFromUrl);
//     }
//   }, [referFromUrl]);

//   const [Phone, setPhone] = useState("");
//   const [twofactor_code, settwofactor_code] = useState("");
//   const [otp, setOtp] = useState(false);
//   const [secretCode, setSecretCode] = useState("");

//   // --- Theme Colors from Screenshot ---
//   const colors = {
//     smokeWhite: "#F0F4F8",    // Soft, clean background
//     midnightNavy: "#1C2533",  // Primary button and headings
//     mutedText: "#8E9AAF",     // Subtitles
//     accentGold: "#B5894D",    // Input border focus
//     pureWhite: "#FFFFFF",
//   };

//   // --- Enhanced Swal UI ---
//   const customSwal = {
//     confirmButton: 'custom-swal-button',
//     popup: 'custom-swal-popup'
//   };

//   const handleClick = async (e) => {
//     e.preventDefault();
//     if (!Phone || Phone.length !== 10) {
//       Swal.fire({
//         title: "Invalid Number",
//         text: "Please enter a 10-digit mobile number",
//         icon: "warning",
//         confirmButtonColor: colors.midnightNavy,
//         customClass: customSwal
//       });
//       return;
//     }
//     try {
//       const res = await axios.post(`https://api.kakaking.in/login`, { Phone, referral });
//       if (res.data.status === 200) {
//         setOtp(true);
//         setSecretCode(res.data.secret);
//         Swal.fire({ 
//             title: "OTP Sent", 
//             icon: "success", 
//             confirmButtonColor: colors.midnightNavy,
//             timer: 2000 
//         });
//         if (res.data.myToken) {
//           Swal.fire("Demo OTP", res.data.myToken, "info");
//         }
//       } else {
//         Swal.fire("Error", res.data.msg || "Something went wrong", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Unable to connect to server", "error");
//     }
//   };

//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await axios.post(`https://api.kakaking.in/login/finish`, {
//         Phone, otp: twofactor_code, referral, secretCode,
//       });
//       if (res.data.status === 200) {
//         localStorage.setItem("token", res.data.token);
//         Swal.fire({ title: "Success!", text: "Redirecting...", icon: "success", showConfirmButton: false });
//         setTimeout(() => {
//             window.location.reload(true);
//             history.push("/");
//         }, 1500);
//       } else {
//         Swal.fire("Invalid OTP", "Please check the code and try again", "error");
//       }
//     } catch {
//       Swal.fire("Error", "Verification failed!", "error");
//     }
//   };

//   const [isValid, setIsValid] = useState(false);
//   const [showResend, setShowResend] = useState(false);
//   const [seconds, setSeconds] = useState(60);

//   useEffect(() => {
//     let timer;
//     if (isValid && seconds > 0) {
//       timer = setInterval(() => setSeconds((s) => s - 1), 1000);
//     } else if (seconds === 0) {
//       setShowResend(true);
//       setIsValid(false);
//     }
//     return () => clearInterval(timer);
//   }, [isValid, seconds]);

//   const handleResendClick = (e) => {
//     handleClick(e);
//     setIsValid(true);
//     setSeconds(60);
//     setShowResend(false);
//   };

//   // --- UI Components ---
//   const styles = {
//     page: {
//       background: `linear-gradient(180deg, #D6E4EE 0%, ${colors.smokeWhite} 100%)`,
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       fontFamily: "'Inter', sans-serif",
//       padding: "20px"
//     },
//     card: {
//       // background: colors.pureWhite,
//     backgroundImage: `url("/images/loginbg.AVIF")`, // Wrap it in backticks or quotes
// backgroundSize: "cover",                      // Optional: ensures the image fits
// backgroundPosition: "center",
//       borderRadius: "40px",
//       width: "100%",
//       maxWidth: "400px",
//       padding: "20px 30px",
//       boxShadow: "0 20px 50px rgba(0, 0, 0, 0.05)",
//       textAlign: "center",
//       position: "relative"
//     },
//     logoCircle: {
//       width: "90px",
//       height: "90px",
//       background: "#000",
//       borderRadius: "25px",
//       margin: "0 auto 20px auto",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       boxShadow: "0 10px 20px rgba(28, 37, 51, 0.2)"
//     },
//     label: {
//       display: "block",
//       textAlign: "left",
//       fontSize: "12px",
//       fontWeight: "700",
//       color: "#000",
//       marginBottom: "10px",
//       letterSpacing: "0.5px"
//     },
//     inputContainer: {
//       border: `2px solid ${colors.accentGold}`,
//       borderRadius: "18px",
//       display: "flex",
//       alignItems: "center",
//       padding: "5px 15px",
//       marginBottom: "25px",
//       background: colors.pureWhite
//     },
//     button: {
//       background:"#000",
//       color: "white",
//       width: "100%",
//       padding: "18px",
//       borderRadius: "18px",
//       border: "none",
//       fontSize: "16px",
//       fontWeight: "700",
//       cursor: "pointer",
//       transition: "0.3s",
//       marginTop: "10px"
//     },
//     footerText: {
//       fontSize: "13px",
//       color: colors.mutedText,
//       marginTop: "30px",
//       lineHeight: "1.6"
//     }
//   };

//   return (
//     <div style={styles.page}>
//       <div style={styles.card}>
        
//         {/* Header Section */}
//         <div style={styles.logoCircle}>
//            <img src="/images/addanew.png" alt="Logo" style={{ height: "80px" }} />
//         </div>
//         <h2 style={{ color: colors.midnightNavy, fontSize: "28px", margin: "0 0 5px 0" }}>Welcome Back</h2>
//         <p style={{ color: colors.mutedText, marginBottom: "35px" }}>Sign in to your account to continue</p>

//         <form>
//           {!otp ? (
//             <>
//               <label style={styles.label}>MOBILE NUMBER</label>
//               <div style={styles.inputContainer}>
//                 <span style={{ fontWeight: "bold", marginRight: "10px", color: colors.midnightNavy }}>+91</span>
//                 <input
//                   type="tel"
//                   placeholder="00000 00000"
//                   value={Phone}
//                   onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
//                   style={{ border: "none", outline: "none", fontSize: "18px", width: "100%", height: "45px" }}
//                 />
//               </div>
//               <button 
//                 type="submit" 
//                 style={styles.button} 
//                 onClick={(e) => { handleClick(e); setIsValid(true); }}
//               >
//                 Get OTP
//               </button>
//             </>
//           ) : (
//             <>
//               <label style={styles.label}>VERIFICATION CODE</label>
//               <div style={styles.inputContainer}>
//                 <input
//                   type="text"
//                   placeholder="Enter 6-digit OTP"
//                   value={twofactor_code}
//                   onChange={(e) => settwofactor_code(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                   style={{ border: "none", outline: "none", fontSize: "18px", width: "100%", height: "45px", textAlign: "center", letterSpacing: "5px" }}
//                 />
//               </div>
//               <div style={{ textAlign: "right", fontSize: "12px", marginBottom: "15px" }}>
//                 {seconds === 0 ? (
//                   <span onClick={handleResendClick} style={{ color: colors.accentGold, cursor: "pointer", fontWeight: "bold" }}>Resend OTP</span>
//                 ) : (
//                   <span style={{ color: colors.mutedText }}>Resend in {seconds}s</span>
//                 )}
//               </div>
//               <button type="submit" style={styles.button} onClick={verifyOtp}>
//                 Verify & Enter
//               </button>
//             </>
//           )}
//         </form>

        
//       </div>
//       <div style={styles.footerText}>
//             By continuing, you agree to our <b style={{color: '#007AFF'}}>Privacy Policy</b> & <b style={{color: '#007AFF'}}>Terms</b>
//             <div style={{ marginTop: "20px", fontSize: "11px", fontStyle: "italic" }}>
//                 18+ Only. Restricted in Assam, Odisha, Nagaland, Sikkim, AP & Telangana.
//             </div>
//         </div>
//     </div>
//   );
// }



import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
// import "./Login.css";

export default function Login() {
  const history = useHistory();
  const location = useLocation();

  // =========================
  // LOGIC - UNCHANGED
  // =========================

  const queryParams = new URLSearchParams(location.search);
  const referFromUrl = queryParams.get("refer");

  const [referral, setReferral] = useState(
    referFromUrl || localStorage.getItem("referral") || ""
  );

  useEffect(() => {
    if (referFromUrl) {
      localStorage.setItem("referral", referFromUrl);
      setReferral(referFromUrl);
    }
  }, [referFromUrl]);

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [secretCode, setSecretCode] = useState("");

  const colors = {
    midnightNavy: "#172033",
    mutedText: "#7C8798",
    accentGold: "#B5894D",
    pureWhite: "#FFFFFF",
  };

  const customSwal = {
    confirmButton: "custom-swal-button",
    popup: "custom-swal-popup",
  };

  const handleClick = async (e) => {
    e.preventDefault();

    if (!Phone || Phone.length !== 10) {
      Swal.fire({
        title: "Invalid Number",
        text: "Please enter a 10-digit mobile number",
        icon: "warning",
        confirmButtonColor: colors.midnightNavy,
        customClass: customSwal,
      });
      return;
    }

    try {
      const res = await axios.post(
        `https://api.kakaking.in/login`,
        { Phone, referral }
      );

      if (res.data.status === 200) {
        setOtp(true);
        setSecretCode(res.data.secret);

        Swal.fire({
          title: "OTP Sent",
          icon: "success",
          confirmButtonColor: colors.midnightNavy,
          timer: 2000,
        });

        if (res.data.myToken) {
          Swal.fire("Demo OTP", res.data.myToken, "info");
        }
      } else {
        Swal.fire(
          "Error",
          res.data.msg || "Something went wrong",
          "error"
        );
      }
    } catch {
      Swal.fire("Error", "Unable to connect to server", "error");
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        `https://api.kakaking.in/login/finish`,
        {
          Phone,
          otp: twofactor_code,
          referral,
          secretCode,
        }
      );

      if (res.data.status === 200) {
        localStorage.setItem("token", res.data.token);

        Swal.fire({
          title: "Success!",
          text: "Redirecting...",
          icon: "success",
          showConfirmButton: false,
        });

        setTimeout(() => {
          window.location.reload(true);
          history.push("/");
        }, 1500);
      } else {
        Swal.fire(
          "Invalid OTP",
          "Please check the code and try again",
          "error"
        );
      }
    } catch {
      Swal.fire("Error", "Verification failed!", "error");
    }
  };

  const [isValid, setIsValid] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    let timer;

    if (isValid && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((s) => s - 1);
      }, 1000);
    } else if (seconds === 0) {
      setShowResend(true);
      setIsValid(false);
    }

    return () => clearInterval(timer);
  }, [isValid, seconds]);

  const handleResendClick = (e) => {
    handleClick(e);
    setIsValid(true);
    setSeconds(60);
    setShowResend(false);
  };

  // =========================
  // UI
  // =========================

  return (
    <div className="login-page">

      {/* 3D Background Objects */}
      <div className="login-orb orb-one"></div>
      <div className="login-orb orb-two"></div>
      <div className="login-orb orb-three"></div>

      <div className="login-scene">

        {/* Main Card */}
        <div className="login-card">

          {/* Top Shine */}
          <div className="card-shine"></div>

          {/* Logo */}
          <div className="login-logo-wrap">
            <div className="login-logo">
              <img
                src="/images/addanew.png"
                alt="Logo"
              />
            </div>
          </div>

          {/* Header */}
          <div className="login-header">
            <h1>Welcome Back</h1>

            <p>
              Sign in to your account
              <br />
              and continue playing
            </p>
          </div>

          {/* Form */}
          <form>

            {!otp ? (
              <>
                {/* Mobile Label */}
                <label className="login-label">
                  MOBILE NUMBER
                </label>

                {/* Mobile Input */}
                <div className="login-input-box">

                  <div className="country-code">
                    <span className="india-flag">🇮🇳</span>
                    <span>+91</span>
                  </div>

                  <div className="input-divider"></div>

                  <input
                    type="tel"
                    placeholder="00000 00000"
                    value={Phone}
                    onChange={(e) =>
                      setPhone(
                        e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10)
                      )
                    }
                  />

                </div>

                {/* Get OTP */}
                <button
                  type="submit"
                  className="login-main-btn"
                  onClick={(e) => {
                    handleClick(e);
                    setIsValid(true);
                  }}
                >
                  <span>Get OTP</span>
                  <span className="button-arrow">→</span>
                </button>
              </>
            ) : (
              <>
                {/* OTP Label */}
                <label className="login-label">
                  VERIFICATION CODE
                </label>

                {/* OTP Input */}
                <div className="login-input-box otp-box">

                  <div className="otp-icon">
                    ✦
                  </div>

                  <input
                    type="text"
                    placeholder="Enter 6-digit OTP"
                    value={twofactor_code}
                    onChange={(e) =>
                      settwofactor_code(
                        e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 6)
                      )
                    }
                  />

                </div>

                {/* Resend */}
                <div className="resend-row">

                  {seconds === 0 ? (
                    <span
                      onClick={handleResendClick}
                      className="resend-active"
                    >
                      Resend OTP
                    </span>
                  ) : (
                    <span className="resend-disabled">
                      Resend in{" "}
                      <b>{seconds}s</b>
                    </span>
                  )}

                </div>

                {/* Verify */}
                <button
                  type="submit"
                  className="login-main-btn"
                  onClick={verifyOtp}
                >
                  <span>Verify & Enter</span>
                  <span className="button-arrow">→</span>
                </button>
              </>
            )}

          </form>

          {/* Security Badge */}
          <div className="secure-badge">
            <span className="secure-icon">✓</span>
            <span>Secure & encrypted login</span>
          </div>

        </div>

        {/* Footer */}
        <div className="login-footer">

          <div className="agreement">
            By continuing, you agree to our
            <span> Privacy Policy</span>
            {" & "}
            <span>Terms</span>
          </div>

          

        </div>

      </div>
    </div>
  );
}